import { Select } from 'antd';
import { t } from 'i18next';

import { Location } from '@/models';

type SelectMultipleLocationsProps = {
  selectedLocations: string[];
  locations?: Location[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
};

export const SelectMultipleLocations = ({
  selectedLocations,
  locations,
  onChange,
  disabled,
}: SelectMultipleLocationsProps) => {
  return (
    <Select
      aria-label={t('common:locations')}
      mode='multiple'
      value={selectedLocations}
      popupMatchSelectWidth={false}
      maxTagCount={'responsive'}
      disabled={disabled}
      showSearch={{
        filterOption: (input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
        optionFilterProp: 'children',
      }}
      placeholder={t('common:locations')}
      options={locations?.map((location) => ({
        value: location.id,
        label: `${location.name} (${location.city})`,
      }))}
      onChange={onChange}
      onClear={() => onChange([])}
      allowClear
      style={{ width: 200 }}
    />
  );
};
